import { AppEnvironment } from '@web/csl-lib-models';

export const environment: AppEnvironment = {
  version: '3.1.38',
  production: false,
  featureFlagEnvironment: 'dev',
  name: 'Cancer SurvivorLink Clinic Portal [DEV]',
  apiUrl: 'https://cslapi.csldev.xyz',
  logoutRedirectUrl: "https://csldev.xyz",
  msalConfig: {
    auth: {
      clientId: 'e17f5e36-2d54-4110-82b3-67c617e1bf32',
      authority: 'https://cslnonprod.b2clogin.com/cslnonprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_CSL',
    },
    redirectUri: 'https://clinic.csldev.xyz/hr-index',
  },
  apiConfig: {
    scopes: [
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.documents.write',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.healthrecords.documents.write',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.healthrecords.legalguardian.write',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.healthrecords.patient.write',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.healthrecords.read',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.medicalrecordreleases.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.messages.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.ownertransfers.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.scpworklist.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.staff.read',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.staff.write',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.users.read',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/clinic.users.write',
    ],
    uri: 'https://cslapi.csldev.xyz', // API endpoint URL
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN_CSL'
    },
    authorities: {
      signUpSignIn: {
        authority:
          'https://login.csldev.xyz/e5337cb4-f730-4f54-bcad-70710c429ea4/B2C_1A_SIGNUP_SIGNIN_CSL',
      }
    },
    authorityDomain: 'login.csldev.xyz',
  },
  cacheTimeInMinutes: 30,
  primeNgLicenseKey: 'eyJpZCI6ImQ1ZWEyZjA0LWQ1ZGEtNDAzOS1iMzM2LWRkODM1MWQ5Njg0ZiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzg0OTc4NzA1LCJleHAiOjE4MTY1MTQ2NjV9.ZXZ4cOdbvDJiyNrSiVAmPO-vJHHc6MFK23Zy573BOvR3yJboxx1ligQkH21asMOTVd44LMhshpYtmk94ZEd1AQ',
};
